import { useContext, useEffect, useRef } from 'react';
import axiosInstanceGenerator from '../../utils/axiosInstance';

import { parseQueryString } from '@src/utils/general';

import {
  apiBandUpdatedDeliveryDate,
  apiExtendedDetail
} from '../../app_routes/bands';

import { BandStateContext, BandDispatchContext } from '../../contexts/band';

import { handleError } from '../../utils/errors';

import type { TBandDetail } from '../../types/band';

function DeliveryDate() {
  const { setBand } = useContext(BandDispatchContext);
  const { band } = useContext(BandStateContext);
  const bandDataRef = useRef(band);
  const axios = axiosInstanceGenerator();
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  const sku = band ? band.vendor_sku : undefined;

  bandDataRef.current = band;

  useEffect(() => {
    if (!sku) return;

    axios
      .get(apiBandUpdatedDeliveryDate(sku), {
        cancelToken: source.token
      })
      .then(res => {
        setBand({
          ...bandDataRef.current,
          delivery_date: res.data
        });
      })
      .catch(handleError);

    return () => {
      source.cancel('Unmounting');
    };
  }, [sku]);

  return null;
}

function ExtendedData() {
  const { setBand } = useContext(BandDispatchContext);
  const { band } = useContext(BandStateContext);
  const bandDataRef = useRef(band);
  const axios = axiosInstanceGenerator();
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  const sku = band ? band.vendor_sku : undefined;

  bandDataRef.current = band;

  useEffect(() => {
    if (!sku) return;

    const matchingSku =
      typeof window !== 'undefined' &&
      parseQueryString(window.location.search).matching_sku;

    axios
      .get(apiExtendedDetail(sku, { matching_sku: matchingSku }), {
        cancelToken: source.token
      })
      .then(res => {
        setBand({
          ...bandDataRef.current,
          ...res.data
        });
      })
      .catch(handleError);

    return () => {
      source.cancel('Unmounting');
    };
  }, [sku]);

  return null;
}

function Band() {
  return [
    <DeliveryDate key='delivery-date' />,
    <ExtendedData key='extended-data' />
  ];
}

export default Band;
